import { Button, ButtonOptions } from '@goodboydigital/astro';
import { Sprite, Texture } from 'pixi.js';

import { Shared } from '../App';

export interface RadioButtonOpts extends ButtonOptions
{
    active?: boolean,
    iconOn: string,
    iconOff?: string,
    padding?: number,
}

export class RadioButton extends Button
{
    public view: Sprite;
    public width: number;
    public height: number;

    protected icon: Sprite;
    protected radioIcon: Sprite;

    private _iconOffTexture: Texture;
    private _iconOnTexture: Texture;

    private _active: boolean;
    private _radioIconOffTexture: Texture;
    private _radioIconOnTexture: Texture;

    constructor(o: RadioButtonOpts)
    {
        const view = new Sprite();

        super(view, o);

        this.view = view;
        this._active = o.active || false;

        // view anchored to 0, 0.5 to make life easier positioning things with the RadioSelector
        this.view.anchor.set(0, 0.5);

        this._radioIconOffTexture = Shared.assets.getTexture('radio-button-off');
        this._radioIconOnTexture = Shared.assets.getTexture('radio-button-on');

        this.radioIcon = Sprite.from(this._active ? this._radioIconOnTexture : this._radioIconOffTexture);
        this.view.addChild(this.radioIcon);

        this._iconOnTexture = Shared.assets.getTexture(o.iconOn);
        this._iconOffTexture = Shared.assets.getTexture(o.iconOff ? o.iconOff : o.iconOn);

        const pad = o.padding || 2;

        this.icon = Sprite.from(this._active ? this._iconOnTexture : this._iconOffTexture);
        this.icon.x = this.radioIcon.width + pad;
        this.view.addChild(this.icon);

        this.onPress.connect(() =>
        {
            this.state = !this._active;
            Shared.game.soundSystem.playSfx('btn-click');
        });

        this.width = this.radioIcon.width + pad + this.icon.width;
        this.height = Math.max(this.radioIcon.width, this.radioIcon.width);
    }

    public get state(): boolean { return this._active; }
    public set state(state: boolean)
    {
        this._active = state;
        this.icon.texture = this._active ? this._iconOnTexture : this._iconOffTexture;
        this.radioIcon.texture = this._active ? this._radioIconOnTexture : this._radioIconOffTexture;
    }
}
